import { CommonModule } from '@angular/common';
import { Component, computed, Inject, signal, Signal, WritableSignal, inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Entry } from '@app/_models/entry.model';
import { SettingsService } from '@app/_services/settings.service';
import { SvgComponent } from '@app/components/shared/svg/svg.component';
import { TodoBlockComponent } from '../../todos/todo-block/todo-block.component';
import { HabitBlockComponent } from '../../habits/habit-block/habit-block.component';
import { JournalBlockComponent } from '../../journals/journal-block/journal-block.component';
import { CalendarEventBlockComponent } from '../../calendar-integration/calendar-event-block/calendar-event-block.component';
import { MoneyTrackerBlockComponent } from '../../money-tracker/money-tracker-block/money-tracker-block.component';
import { FeatureStore } from '@app/_stores';
import { FocusBlockComponent } from '../../focus-tracker/focus-block/focus-block.component';
import { NoteBlockComponent } from '../../notes/note-block/note-block.component';
import { CustomBottomSheetRef } from '@app/_services/custom-bottom-sheet.service';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-entity-entries',
  imports: [
    CommonModule,
    SvgComponent,
    TodoBlockComponent,
    HabitBlockComponent,
    JournalBlockComponent,
    MoneyTrackerBlockComponent,
    CalendarEventBlockComponent,
    FocusBlockComponent,
    NoteBlockComponent
  ],
  templateUrl: './entity-entries.component.html',
  styleUrl: './entity-entries.component.scss'
})

export class EntityEntriesComponent {
  public data: { entityIds: string[], dateString: string, title: string, includeScheduled?: boolean };
  readonly featureStore = inject(FeatureStore);
  entries: Signal<Entry[]> = computed(() => {
    // Support both scheduled and unscheduled events
    const allEntries = this.data.includeScheduled
      ? [...this.featureStore.entries().withoutTime, ...this.featureStore.entries().withTime]
      : this.featureStore.entries().withoutTime;
    const filteredEntries = allEntries.filter(e => this.data.entityIds.includes(e.setupId))

    // Sort by duration (longest first) to match calendar display order
    filteredEntries.sort((a, b) => {
      const durationA = a.totalDays;
      const durationB = b.totalDays;

      if (durationB !== durationA) {
        return durationB - durationA; // Primary: Duration descending (longest first)
      }

      // Secondary: Alphabetical by title for same duration
      return (a.sortTitle || '').localeCompare(b.sortTitle || '');
    });

    return filteredEntries
  });
  show: string[] = ['repeat'];
  dateString: Signal<string> = computed(() => {
    return this.data.dateString;
  });
  device: WritableSignal<'mobile' | 'tablet' | 'desktop'> = signal('desktop');
  title: Signal<string> = computed(() => {
    return this.data.title;
  });

  constructor(
    public ss: SettingsService,
    @Optional() public dialogRef: MatDialogRef<EntityEntriesComponent> | null,
    @Optional() public bottomSheetRef: CustomBottomSheetRef<EntityEntriesComponent> | null,
    @Optional() @Inject(MAT_DIALOG_DATA) dialogData: { entityIds: string[], dateString: string, title: string, includeScheduled?: boolean } | null,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) bottomSheetData: { entityIds: string[], dateString: string, title: string, includeScheduled?: boolean } | null,

  ) {
    this.data = (dialogData || bottomSheetData)!;
  }


  closeDialog() {
    this.close();
  };

  private close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss();
    }
  }

}
